module.exports = {
  siteMetadata: {
    siteUrl: `https://staging.hellohealth.com`,
    defaultTitle: `Hello Health the First EHR in US - Technology Made for Independent Medical Practices`,
    defaultDescription: `Electronic Health Record, Practice Management System, Patient Portal and Telehealth solution. See how doctors can access medical technology from anywhere and optimize their workflow.`,
    siteLanguage: `en-US`
  },
  plugins: [
    `gatsby-plugin-preact`,
    `gatsby-plugin-react-helmet`,
    {
      resolve: `gatsby-plugin-react-helmet-canonical-urls`,
      options: {
        siteUrl: `https://staging.hellohealth.com`,
      },
    },
    {
      resolve: '@slixites/gatsby-plugin-google-fonts',
      options: {
        fonts: [
          `Merriweather:300,400,700`,
          `Work Sans:300,400,500,600,700`
        ],
        display: 'swap',
        preconnect: true,
        attributes: {
            rel: 'stylesheet preload prefetch',
            as: 'style',
        },
      }
    },
    {
      resolve: `gatsby-source-filesystem`,
      options: {
        name: `images`,
        path: `${__dirname}/src/images`,
      },
    },
    {
      resolve: "gatsby-plugin-react-svg",
      options: {
        rule: {
          include: /\.inline\.svg$/
        }
      },
    },
    `gatsby-plugin-image`,
    `gatsby-transformer-sharp`,
    {
      resolve: `gatsby-plugin-sharp`,
      options: {
        defaults: {
          formats: [`auto`],
          placeholder: `dominantColor`,
          quality: 100,
          backgroundColor: `transparent`,
        },
      },
    },
    {
      resolve: `gatsby-plugin-manifest`,
      options: {
        name: `gatsby-starter-default`,
        short_name: `starter`,
        start_url: `/`,
        background_color: `#663399`,
        theme_color: `#663399`,
        display: `minimal-ui`,
        icon: `src/images/favicon.png`, // This path is relative to the root of the site.
      },
    },
    {
      resolve: "gatsby-source-wordpress",
      options: {
        //url: `http://localhost/cms-us-hellohealth-2021/graphql`,
        // url: `https://hh.s7yutsuu-liquidwebsites.com/index.php?graphql`,
        // url:'https://hellohealthweb.wpengine.com/index.php?graphql',
        url:'https://aed445648b.nxcli.net/graphql',
      },
    },
    {
      resolve: `gatsby-transformer-remark`,
      options: {
        plugins: [`gatsby-remark-responsive-iframe`],
      },
    },
    `gatsby-plugin-sass`,
    {
      resolve: `gatsby-plugin-sitemap`,
      options: {
        exclude:
          [`/example-table`,
            `/pdf-implementation/*`,
            `/what-s-new/*`,
            `/thank-you/`,
            `/thank-you/?cpid=*`,
          ],
        query: `
        {
          site {
            siteMetadata {
              siteUrl
            }
          }
          allSitePage {
            edges {
              node {
                path
              }
            }
          }
        }`,
        serialize: ({ site, allSitePage }) =>
        allSitePage.edges.map(edge => {
          return {
            url: site.siteMetadata.siteUrl + edge.node.path,
            changefreq: `monthly`,
            priority: 1.0,
          }
        }),
      }
    },
    {
      resolve: 'gatsby-plugin-robots-txt',
      options: {
        host: 'https://staging.hellohealth.com',
        sitemap: 'https://staging.hellohealth.com/sitemap.xml',
        policy: [
          { userAgent: '*',
            disallow:
              ['/example-table',
                '/pdf-implementation/*',
                '/what-s-new/*',
                '/thank-you/',
                '/thank-you/?cpid=*',
              ]
          }
        ]
      }
    },
    {
      resolve: "gatsby-plugin-google-tagmanager",
      options: {
        id: "GTM-WVLPX2M",

        // Include GTM in development.
        // Defaults to false meaning GTM will only be loaded in production.
        includeInDevelopment: false,

        // datalayer to be set before GTM is loaded
        // should be an object or a function that is executed in the browser
        // Defaults to null
        defaultDataLayer: { platform: "gatsby" },
      },
    },
  ],
}
